/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  isNetpayInitialized: false,
  tiposDeNoticias: [],
  noticias: { results: [] },
  noticiasHome: [],
  carousels: [],
  lastINPC: null,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    clearApp: (state) => {
      Object.keys(state).forEach((key) => {
        state[key] = initialState[key] || [];
      });
    },
    setIsNetpayInitialized: (state) => {
      state.isNetpayInitialized = true;
    },

    setTiposDeNoticias: (state, { payload }) => {
      state.tiposDeNoticias = payload;
    },
    setNoticias: (state, { payload }) => {
      state.noticias = payload;
    },
    setNoticiasHome: (state, { payload }) => {
      state.noticiasHome = payload;
    },
    setCarousels: (state, { payload }) => {
      state.carousels = payload;
    },
    setINPC: (state, { payload }) => {
      state.lastINPC = payload;
    },
  },
});

export const {
  clearApp,
  setIsNetpayInitialized,
  setTiposDeNoticias,
  setNoticias,
  setNoticiasHome,
  setCarousels,
  setINPC,
} = appSlice.actions;

// Data Selectors
export const selectIsNetpayInitialized = ({ app }) => !!app.isNetpayInitialized;
export const selectTiposDeNoticias = (s) => s.app.tiposDeNoticias || [];
export const selectNoticias = (s) => s.app.noticias;
export const selectNoticiasHome = (s) => s.app.noticiasHome;
export const selectCarousels = (s) => s.app.carousels;
export const selectINPC = (s) => s.app.lastINPC;

export default appSlice.reducer;
